import { Injectable } from '@angular/core';
import { AppErrors } from '@fitness-force/errors';
import { ToastMessageService } from '@fitness-force/api';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(public toastMessageService: ToastMessageService) {}
  
  private errorSubject = new Subject<AppErrors>();

  get error$() {
    return this.errorSubject.asObservable();
  }

  handleError(error: AppErrors) {
    this.errorSubject.next(error);
  }
}